import React from "react";
import { useNavigate } from "react-router-dom";
import { Nfc, QrCode } from "lucide-react";
import { Label, InfoBadge } from "./common";
import { feedbackHref } from "../lib/feedbackLink";
import { periodLabel } from "./PeriodFilter";

function SplitRow({ title, s, onPick, testId }) {
  return (
    <div data-testid={testId}>
      <div className="mb-1.5 flex items-baseline justify-between">
        <p className="font-head text-sm font-bold text-slate-900">{title}</p>
        <span className="text-xs text-slate-400" data-testid={`${testId}-total`}>{s.total.toLocaleString()} total</span>
      </div>
      <div className="flex h-3 overflow-hidden rounded-full bg-slate-100">
        <div className="bg-[#4338CA]" style={{ width: `${s.nfc_pct}%` }} />
        <div className="bg-amber-400" style={{ width: `${s.qr_pct}%` }} />
      </div>
      <div className="mt-2 grid grid-cols-2 gap-2">
        {[["nfc", "NFC tap", Nfc, "text-[#4338CA]"], ["qr", "QR scan", QrCode, "text-amber-500"]].map(([k, label, Icon, cls]) => (
          <button key={k} onClick={onPick ? () => onPick(k) : undefined} disabled={!onPick}
            className={`rounded-lg border border-slate-100 p-2.5 text-left ${onPick ? "hover:border-indigo-300 hover:bg-indigo-50/30" : "cursor-default"}`} data-testid={`${testId}-${k}`}>
            <span className={`flex items-center gap-1 text-xs font-bold ${cls}`}><Icon className="h-3.5 w-3.5" />{label}</span>
            <span className="sv-metric text-xl font-bold text-slate-900">{s[k].toLocaleString()}</span>
            <span className="ml-1.5 text-sm font-semibold text-slate-500">{s[`${k}_pct`]}%</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default function ChannelSplit({ channels, days, locationId, testId = "channel-split" }) {
  const navigate = useNavigate();
  if (!channels) return null;
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5" data-testid={testId}>
      <span className="flex items-center gap-1.5"><Label>NFC vs QR · {periodLabel(days)}</Label>
        <InfoBadge title="NFC vs QR" testId={`${testId}-info`}
          text="How customers reached your rating page: tapping the NFC tag or scanning the QR code. Scans count every open of the page; ratings count submitted feedback. Click a ratings figure to see those ratings." /></span>
      <div className="mt-4 grid gap-6 md:grid-cols-2">
        <SplitRow title="Scans / taps" s={channels.scans} testId={`${testId}-scans`} />
        <SplitRow title="Ratings submitted" s={channels.ratings} testId={`${testId}-ratings`}
          onPick={(src) => navigate(feedbackHref({ location_id: locationId, days, source: src }))} />
      </div>
    </div>
  );
}
